import axiosConfig from "./axiosConfig";

export interface SiteTableInfo {
  exists: boolean;
  row_count: number;
}

export interface SiteReadingsTablesResponse {
  site_id: string;
  exists: boolean;
  raw: SiteTableInfo;
  history: SiteTableInfo;
  processed: SiteTableInfo;
}

const getSiteReadingsTables = async (
  authToken: string,
  siteId: string
): Promise<SiteReadingsTablesResponse> => {
  const { data } = await axiosConfig.get(
    `/site/${siteId}/ingestion/readings_tables`,
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }
  );
  return data;
};

export default getSiteReadingsTables;
